const list = {
  path: 'list',
  component: resolve => require(['../../../../../pages/user/course/calendar/list'], resolve)
}

export default list



// WEBPACK FOOTER //
// ./src/router/user/course/calendar/list/index.js